import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '../../component-base';
import { AuthForignerService } from 'src/app/shared/services/authentication/authforigner.service';
import { ChangepasswordDto } from 'src/app/shared/models/changepassword.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent extends BaseComponent{
  form: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private authservice:AuthForignerService,
    public override translate?: TranslateService){
    super();
  }

  ngOnInit() {   
    this.fillBreadCrumb();
    this.initForm();
  }

  initForm() {
    this.form = this.formBuilder.group({
      token: ['',Validators.required],
      password: ['',Validators.required],     
      newpassword: ['',Validators.required]      
    },
    );
  }
  private fillBreadCrumb() {
    this.breadcrumbItems = [
            { label: 'shared.changepassword', url: '/changepassword'}
    ];
  }
  changepassword(){
    let changpassword:ChangepasswordDto=new ChangepasswordDto();
    changpassword.oldPassword = this.form.controls["password"].value;
    changpassword.newPassword = this.form.controls["newpassword"].value;
    this.authservice.ChangePassword(changpassword).subscribe(result=>{
      if (result.value) {
        this.done(this.translate.instant('shared.doneSuccessfully') );

      }
      else this.failed(this.translate.instant('shared.error'));
      
    });
    
  }
}
